module.exports = __webpack_public_path__ + "static/media/pixel_selfie.81046d07.png";